import TTooltip from './Tooltip.vue'

export const Tooltip = TTooltip
